import React, { useState } from 'react';

const EmailLayer = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        smtpHost: '',
        smtpPort: '',
        emailContentType: 'text',
        smtpEncryption: 'off',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // In a real application, you would replace this URL with your actual API endpoint
        const apiUrl = '/api/save-smtp-settings';

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('SMTP settings saved successfully!');
                // Optionally, you can show a success message to the user
            } else {
                console.error('Failed to save SMTP settings.');
                // Optionally, you can show an error message to the user
            }
        } catch (error) {
            console.error('There was an error saving the SMTP settings:', error);
            // Optionally, you can show an error message to the user
        }
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="email"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Email <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="email"
                                    className="form-control radius-8"
                                    id="email"
                                    name="email"
                                    placeholder="Enter your email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="password"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Password <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="password"
                                    className="form-control radius-8"
                                    id="password"
                                    name="password"
                                    placeholder="Enter your password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="smtpHost"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    SMTP Host <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control radius-8"
                                    id="smtpHost"
                                    name="smtpHost"
                                    placeholder="Enter SMTP Host"
                                    value={formData.smtpHost}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="smtpPort"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    SMTP Port <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control radius-8"
                                    id="smtpPort"
                                    name="smtpPort"
                                    placeholder="Enter SMTP Port"
                                    value={formData.smtpPort}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="emailContentType"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Email Content Type <span className="text-danger-600">*</span>
                                </label>
                                <select
                                    className="form-control radius-8 form-select"
                                    id="emailContentType"
                                    name="emailContentType"
                                    value={formData.emailContentType}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="text">Text</option>
                                    <option value="html">HTML</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="smtpEncryption"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    SMTP Encryption <span className="text-danger-600">*</span>
                                </label>
                                <select
                                    className="form-control radius-8 form-select"
                                    id="smtpEncryption"
                                    name="smtpEncryption"
                                    value={formData.smtpEncryption}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="off">Off</option>
                                    <option value="ssl">SSL</option>
                                    <option value="tls">TLS</option>
                                </select>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                            <button
                                type="reset"
                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                onClick={() => setFormData({
                                    email: '',
                                    password: '',
                                    smtpHost: '',
                                    smtpPort: '',
                                    emailContentType: 'text',
                                    smtpEncryption: 'off',
                                })}
                            >
                                Reset
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                            >
                                Save Change
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmailLayer;